import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { makeStyles } from "@material-ui/styles";
import { colors } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    flexGrow: 0,
    flexShrink: 0,
    borderRadius: 2,
    lineHeight: "12px",
    fontSize: "12px",
    height: 20,
    minWidth: 20,
    whiteSpace: "nowrap",
    padding: theme.spacing(0.5, 1),
  },
  rounded: {
    borderRadius: 10,
    padding: theme.spacing(0.5),
  },
}));

function Label({ className, variant, color, shape, children, style, ...rest }) {
  const classes = useStyles();
  const rootClassName = clsx(
    {
      [classes.root]: true,
      [classes.rounded]: shape === "rounded",
    },
    className,
  );
  const finalStyle = { ...style };

  if (variant === "contained") {
    finalStyle.backgroundColor = color;
    finalStyle.color = "#FFF";
  } else if (variant === "no-background") {
    // Label is used in a variety of places, and `no-background` was
    // added as an option to limit the scope of the change to the destinations
    // page and destination configuration pages.
    // I think `outlined` is never used from this fn, but unsure.
  } else {
    finalStyle.border = `1px solid ${color}`;
    finalStyle.color = color;
  }

  return (
    <p
      className={`text-textSubtle text-xs ${rootClassName}`}
      {...rest}
      style={finalStyle}
    >
      {children}
    </p>
  );
}

Label.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  color: PropTypes.string,
  shape: PropTypes.oneOf(["square", "rounded"]),
  style: PropTypes.object,
  variant: PropTypes.oneOf(["contained", "outlined", "no-background"]),
};

Label.defaultProps = {
  style: {},
  color: colors.grey[600],
  variant: "contained",
  shape: "square",
};

export default Label;
